import * as React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	frameWrapper: {
		overflow: 'hidden',
		paddingTop: '40.25%' /* 16:9*/,
		//height: 'calc(100vh - 136px) !important',
		position: 'relative',
		borderRadius: '16px 16px 0px 0px',
		height: '100%',
		'& iframe': {
			border: 0,
			height: '100%',
			left: 0,
			position: 'absolute',
			top: 0,
			width: '100%',
		},
	},
}));
interface IFrameProps {
	iframeSrc: string;
	height: string;
	width: string;
	token: string;
	clientId: string;
}
export const IframeComponent: React.FunctionComponent<IFrameProps> = ({
	iframeSrc,
	height,
	width,
	clientId,
	token,
}) => {
	const onLoadHandler = () => {
		sendMessage();
	};
	const classes = useStyles();
	const sendMessage = () => {
		const iframeEl: any = document.getElementById('myframe');
		// Make sure you are sending a string, and to stringify JSON
		iframeEl.contentWindow.postMessage({ ariaToken: token }, '*');
	};

	const esmeversion = process.env.REACT_APP_ESME_APP_VERSION;
	const src = `${iframeSrc}&clientId=${clientId}&appversion=${esmeversion}`;
	return (
		<div className={classes.frameWrapper}>
			<iframe id="myframe" title={'iframe'} src={src} width={width} onLoad={onLoadHandler} />
		</div>
	);
};
